
import React from 'react';
import { Container } from 'react-bootstrap';
import './Business.css';

export const Business = () => (
  <Container fluid className="p-0">

    <div className="business-page">


        <div className="business-wrapper">

          {/* =========================
              כותרת ראשית
          ========================= */}

          <div className="business-header">

            <div className="business-decorator"></div>

            <h1 className="business-main-title">
              תהליך הרישוי, מבנה מחלקת הנדסה וביקורת עסקים
            </h1>

            <p className="business-intro">
              הדרך לרישיון העסק עוברת דרך מספר תחנות מרכזיות:
              משרד הבריאות, מחלקת ההנדסה על שתי יחידותיה,
              ומחלקת ביקורת עסקים.
            </p>

            <p className="business-intro">
              הבנת תפקידה של כל יחידה ומחלקה תסייע לכם לעבור
              את התהליך בצורה חלקה, לחסוך זמן יקר ולמנוע
              טעויות תכנוניות חמורות.
            </p>

            <div className="business-highlight">
              <strong>
                להלן פירוט מבנה תהליך הרישוי והגורמים המעורבים בו:
              </strong>
            </div>

          </div>


          {/* =========================
              שלב 1
          ========================= */}

          <div className="business-stage">

            <div className="business-stage-header">

              <div className="business-stage-number">
                01
              </div>

              <div>
                <h2 className="business-stage-title">
                  בדיקת תקינות וטיפול מול מחלקת הנדסה לעסקים
                </h2>

                <p className="business-stage-subtitle">
                  בדיקת הנכס הפיזי והתאמתו לחוק
                </p>
              </div>

            </div>

            <p className="business-text">
              מחלקת הנדסה לעסקים היא הגוף האמון על בדיקת
              הנכס הפיזי והתאמתו לחוק. כדי לייעל את העבודה,
              המחלקה מחולקת לשתי יחידות נפרדות, כאשר כל אחת
              מהן בוחנת זווית אחרת של העסק שלכם.
            </p>


            {/* יחידה א */}

            <div className="business-inner-card">

              <div className="business-inner-number">
                א
              </div>

              <div>

                <h3 className="business-inner-title">
                  היחידה לתכנון הנדסי
                </h3>

                <p className="business-text">
                  יחידה זו מתמקדת בתכנון הפנימי של העסק
                  ובפונקציונליות שלו. היא מטפלת בתוכניות
                  המפורטות לניהול העסק שהוגשו על ידי בעל
                  מקצוע מוסמך, כגון אדריכל או מהנדס,
                  בהתאם לחוק רישוי עסקים.
                </p>

                <div className="business-question-box">

                  <strong>
                    מה היחידה בודקת?
                  </strong>

                  <ul className="business-list">
                    <li>חלוקת המדורים הפנימית</li>
                    <li>עמידה בשטחי המינימום הנדרשים לסוג העסק</li>
                    <li>פתרונות נגישות לאנשים עם מוגבלויות</li>
                    <li>התאמת התכנון לדרישות החוק</li>
                    <li>תוכנית להצבת פרגוד או סגירת חורף במידת הצורך</li>
                  </ul>

                </div>

              </div>

            </div>


            {/* יחידה ב */}

            <div className="business-inner-card">

              <div className="business-inner-number">
                ב
              </div>

              <div>

                <h3 className="business-inner-title">
                  היחידה לרישוי הנדסי
                </h3>

                <p className="business-text">
                  יחידה זו מתמקדת בחוקיות המבנה והקרקע
                  ומחברת בין חוק רישוי עסקים לבין חוק
                  התכנון והבנייה.
                </p>

                <div className="business-question-box">

                  <strong>
                    מה היחידה בודקת?
                  </strong>

                  <ul className="business-list">
                    <li>האם למבנה קיים היתר בנייה חוקי</li>
                    <li>האם אופי העסק תואם את ייעוד הקרקע</li>
                    <li>התאמה לתוכנית בניין עיר (תב"ע)</li>
                  </ul>

                </div>

                <div className="business-warning">

                  <strong>
                    טיפול בחריגות – שימוש חורג:
                  </strong>

                  <p className="business-small-text">
                    במידה והיחידה מוצאת כי השימוש המבוקש
                    לעסק אינו תואם להיתר הבנייה או לתב"ע
                    הקיימת, הבקשה עשויה לעבור למסלול
                    הסדרה מיוחד – הליך בקשה לשימוש חורג.
                  </p>

                </div>

              </div>

            </div>

          </div>


          {/* =========================
              שלב 2
          ========================= */}

          <div className="business-stage">

            <div className="business-stage-header">

              <div className="business-stage-number">
                02
              </div>

              <div>

                <h2 className="business-stage-title">
                  חוות דעת משרד הבריאות לתכנון העסק
                </h2>

                <p className="business-stage-subtitle">
                  בדיקת תברואה, סניטציה והתאמת התכנון
                </p>

              </div>

            </div>

            <p className="business-text">
              עבור עסקים רבים, בדגש על תחומי המזון,
              הקוסמטיקה והבריאות, אישור משרד הבריאות
              הוא תנאי סף שבלעדיו לא ניתן להתקדם בתהליך.
            </p>


            {/* אישור תוכניות */}

            <div className="business-info-card">

              <div className="business-info-icon">
                ✓
              </div>

              <div>

                <h3 className="business-info-title">
                  אישור תוכניות מוקדם
                </h3>

                <p className="business-text">
                  בשלב זה מוגשות התוכניות האדריכליות
                  המפורטות, בדרך כלל בקנה מידה של 1:50,
                  למשרד הבריאות לצורך קבלת חוות דעת מקדמית.
                </p>

              </div>

            </div>


            {/* תברואה */}

            <div className="business-info-card">

              <div className="business-info-icon">
                ✓
              </div>

              <div>

                <h3 className="business-info-title">
                  תברואה וסניטציה
                </h3>

                <p className="business-text">
                  משרד הבריאות יוודא כי התכנון מונע זיהום
                  צולב וכולל הפרדה מתאימה בין חומרי גלם
                  למוצרים מוכנים, מערכות נידוף וסינון אוויר,
                  מיקומי כיורים ומדורים בהתאם לדרישות,
                  פתרונות להפרדת שומנים ופינוי אשפה.
                </p>

              </div>

            </div>

          </div>


          {/* =========================
              שלב 3
          ========================= */}

          <div className="business-stage">

            <div className="business-stage-header">

              <div className="business-stage-number">
                03
              </div>

              <div>

                <h2 className="business-stage-title">
                  הגשת הבקשה הרשמית לרישיון העסק
                </h2>

                <p className="business-stage-subtitle">
                  הגשת תיק הבקשה למחלקת רישוי עסקים
                </p>

              </div>

            </div>

            <p className="business-text">
              לאחר שהתוכניות קיבלו את אישורן של יחידות
              התכנון והרישוי ההנדסי ושל משרד הבריאות,
              ניתן להגיש רשמית את תיק הבקשה למחלקת
              רישוי עסקים ברשות המקומית.
            </p>


            {/* צ'קליסט */}

            <div className="business-checklist">

              <h3 className="business-checklist-title">
                מה כולל תיק הבקשה?
              </h3>

              <div className="business-check-item">
                <span className="business-check-icon">
                  ✓
                </span>

                <span>
                  תוכניות חתומות
                </span>
              </div>

              <div className="business-check-item">
                <span className="business-check-icon">
                  ✓
                </span>

                <span>
                  חוזים ומסמכים נדרשים
                </span>
              </div>

              <div className="business-check-item">
                <span className="business-check-icon">
                  ✓
                </span>

                <span>
                  אישורי תשלום אגרות
                </span>
              </div>

              <div className="business-check-item">
                <span className="business-check-icon">
                  ✓
                </span>

                <span>
                  חוות הדעת שהתקבלו מגורמי הרישוי
                </span>
              </div>

            </div>


            {/* היתר זמני */}

            <div className="business-success-box">

              <div className="business-success-icon">
                ✓
              </div>

              <div>

                <h3 className="business-success-title">
                  היתר זמני
                </h3>

                <p className="business-text">
                  עם קליטת התיק ובדיקת תקינותו, הרשות
                  רשאית להנפיק היתר זמני המאפשר את פתיחת
                  העסק ותחילת פעילותו, במקביל לניתוב התיק
                  לקבלת אישורים סופיים משאר גורמי הרישוי,
                  כגון כבאות ומשטרה.
                </p>

              </div>

            </div>

          </div>


          {/* =========================
              שלב 4
          ========================= */}

          <div className="business-stage">

            <div className="business-stage-header">

              <div className="business-stage-number">
                04
              </div>

              <div>

                <h2 className="business-stage-title">
                  מחלקת ביקורת עסקים והכנה לסיור בשטח
                </h2>

                <p className="business-stage-subtitle">
                  בדיקה פיזית של העסק והתאמה לתוכניות
                </p>

              </div>

            </div>

            <p className="business-text">
              לאחר שהעסק הוקם או שופץ בהתאם לתוכניות,
              מגיע שלב האכיפה והבדיקה הפיזית בשטח,
              המנוהל על ידי מחלקת ביקורת עסקים.
            </p>


            {/* ביקורת */}

            <div className="business-audit-box">

              <div className="business-audit-icon">
                🔍
              </div>

              <div>

                <h3 className="business-audit-title">
                  ביקורת התאמה ותברואה
                </h3>

                <p className="business-text">
                  מפקחי המחלקה יגיעו לעסק לסיור פיקוח
                  כדי לוודא קיומה של התאמה מלאה ומדויקת
                  בין התוכנית שאושרה לבין הבנייה בפועל
                  בשטח, לצד בדיקה של שמירה על תנאי
                  תברואה נאותים.
                </p>

              </div>

            </div>


            {/* טיפ */}

            <div className="business-tip-box">

              <div className="business-tip-icon">
                💡
              </div>

              <div>

                <h3 className="business-tip-title">
                  כלים לעזרת בעל העסק
                </h3>

                <p className="business-tip-text">
                  כדי להגיע מוכנים לביקורת ולמנוע עיכובים
                  או קנסות, מומלץ להיעזר במשאבים הקיימים
                  באתר העירייה. ניתן למצוא שם את המפרט
                  האחיד לעסקים, טיפים מעשיים של מומחים
                  וטפסי צ'ק ליסט מפורטים שיאפשרו לבצע
                  "בחינת דמה" לעסק לפני הגעת המפקחים.
                </p>

              </div>

            </div>

          </div>


          {/* =========================
              סיכום
          ========================= */}

          <div className="business-summary">

            <div className="business-summary-icon">
              ✓
            </div>

            <div>

              <h2 className="business-summary-title">
                חשוב לזכור
              </h2>

              <p className="business-summary-text">
                תהליך רישוי העסק דורש תיאום בין מספר גורמים
                מקצועיים ורשויות. הכנה מוקדמת, בדיקת הנכס
                ותכנון נכון יכולים לחסוך זמן, כסף ועיכובים
                מיותרים בדרך לקבלת רישיון העסק.
              </p>

            </div>

          </div>

        </div>


    </div>

  </Container>
);